import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { addDoc, updateDoc } from "firebase/firestore";
import {
  announcementsRef,
  getAnnouncementDoc,
  uploadImgAnnouncemnt,
} from "../utils/firestoreHelpers";
import { useState } from "react";

const initialData = {
  title: "",
  type: "System",
  // link: "",
  // date: "",
  description: "",
  // venue: "",
  // tnc: "",
  // showIsInterested: "yes",
};

const initialErrorData = {
  title: "",
  type: "",
  // date: "",
  description: "",
  // venue: "",
  // tnc: "",
  // showIsInterested: "",
  // img: "",
};
const AddAnnouncements = ({ onClose, selected, dialogType }) => {
  const [img, setImg] = useState(null);
  // const [imageList, setImageList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(
    selected ? { ...selected } : { ...initialData }
  );
  const [error, setError] = useState({ ...initialErrorData });

  const validate = () => {
    const { title, type, description } = data;
    let isValid = true;
    let tempError = { ...initialErrorData };
    if (!title) {
      isValid = false;
      tempError["title"] = "Title is required";
    }
    if (!type) {
      isValid = false;
      tempError["type"] = "Type is required";
    }
    if (!description) {
      isValid = false;
      tempError["description"] = "Description is required";
    }
    // if (!date) {
    //   isValid = false;
    //   tempError["date"] = "Date is required";
    // }
    // if (!["yes", "no"].includes(showIsInterested)) {
    //   isValid = false;
    //   tempError["showIsInterested"] = "Please select a valid value";
    // }
    // if (!img) {
    //   isValid = false;
    //   tempError["img"] = "Image is required";
    // }
    setError(tempError);
    return isValid;
  };

  const onSubmit = async () => {
    let isValid = validate();
    if (!isValid) return;
    setLoading(true);
    const {
      title,
      type,
      // date,
      description,
      // venue,
      // tnc,
      // showIsInterested,
      // link,
    } = data;
    let image_url = selected?.image_url || "";
    if (img) image_url = await uploadImgAnnouncemnt(img);
    const payload = {
      image_url,
      title,
      date: new Date(),
      // link,
      type,
      description,
      main_type: "Announcement",
      expired: false,
      deleted: false,
      // venue,
      // tnc,
      // showIsInterested: showIsInterested === "yes",
    };
    // if (showIsInterested) {
    //   payload["interested"] = [];
    //   payload["not_interested"] = [];
    // }
    // console.log({ payload });
    if (selected) {
      const annDoc = getAnnouncementDoc(selected.id);
      await updateDoc(annDoc, payload);
    } else {
      await addDoc(announcementsRef, payload);
    }
    setLoading(false);
    onClose();
  };

  const onChange = (e) => {
    let value = e.target.value;
    const name = e.target.name;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const [fileSizeError, setFileSizeError] = useState("");
  const fileSizeLimit = 1 * 1024 * 1024; // 1 MB limit

  const checkFileSize = (event) => {
    const fileInput = event.target;

    if (fileInput.files.length > 0 && fileInput.files[0].size > fileSizeLimit) {
      setFileSizeError("File size exceeds the 1 mb limit.");
      fileInput.value = ""; // Clear the input
    } else {
      setImg(event.target.files[0]);
      setFileSizeError("");
    }
  };

  return (
    <form>
      <Modal show={true} onHide={() => {}}>
        <Modal.Header>
          <Modal.Title>{`${dialogType} Announcement`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label htmlFor="title" className="form-label d-block">
              Title *
            </label>
            <input
              value={data.title}
              onChange={onChange}
              className="w-100 form-control"
              name="title"
              required
            />
            <p className="text-danger small">{error.title}</p>
          </div>
          {/* <div className="mb-3">
            <label htmlFor="link" className="form-label d-block">
              Link
            </label>
            <input
              value={data.link}
              onChange={onChange}
              className="w-100 form-control"
              name="link"
            />
            <p className="text-danger small">{error.link}</p>
          </div> */}
          <div className="d-flex gap-1">
            <div className="mb-3 flex-fill">
              <label htmlFor="type" className="form-label d-block">
                Type *
              </label>
              <input
                value={data.type}
                onChange={onChange}
                className="w-100 form-control"
                name="type"
                required
              />
              <p className="text-danger small">{error.type}</p>
            </div>
            {/* <div className="mb-3 flex-fill" flex-fill>
              <label htmlFor="date" className="form-label d-block">
                Date
              </label>
              <input
                type="date"
                className="w-100 form-control"
                name="date"
                value={data.date}
                onChange={onChange}
                required
              />
              <p className="text-danger small">{error.date}</p>
            </div> */}
          </div>
          {/* <div className="mb-3">
            <label htmlFor="showIsInterested" className="form-label d-block">
              Show Is Interested Buttons *
            </label>{" "}
            <div className="d-flex gap-4">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="showIsInterested"
                  value={"yes"}
                  id="yes-is-interested"
                  onChange={onChange}
                  checked={data.showIsInterested === "yes"}
                />
                <label class="form-check-label" for="yes-is-interested">
                  Yes
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="no"
                  name="showIsInterested"
                  id="no-is-interested"
                  onChange={onChange}
                  checked={data.showIsInterested === "no"}
                />
                <label class="form-check-label" for="no-is-interested">
                  No
                </label>
              </div>
            </div>
            <p className="text-danger small">{error.showIsInterested}</p>
          </div> */}

          <div className="mb-3">
            <label htmlFor="image" className="form-label d-block">
              Image
            </label>
            <input
              type="file"
              className="w-100 form-control"
              name="image"
              // onChange={(e) => {
              //   // setImageList(e.target.files);
              //   setImg(e.target.files[0]);
              // }}
              onChange={checkFileSize}
              // multiple={true}
              required
            />
            <p className="text-danger small mt-1">{fileSizeError}</p>
            {/* <p className="text-danger small">{error.img}</p> */}
          </div>
          <div className="mb-3">
            <label htmlFor="description" className="form-label d-block">
              Description *
            </label>
            <textarea
              value={data.description}
              className="w-100 form-control"
              name="description"
              onChange={onChange}
            />
          </div>
          {/* <div className="mb-3">
            <label htmlFor="venue" className="form-label d-block">
              Venue
            </label>
            <textarea
              value={data.venue}
              className="w-100 form-control"
              name="venue"
              onChange={onChange}
            />
          </div> */}
          {/* <div className="mb-3">
            <label htmlFor="tnc" className="form-label d-block">
              Terms and condition
            </label>
            <textarea
              value={data.tnc}
              className="w-100 form-control"
              name="tnc"
              onChange={onChange}
            />
          </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={onSubmit} disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-grow spinner-grow-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default AddAnnouncements;
